const SNACKBAR_FAVORITE = 'snackbar/SNACKBAR_FAVORITE';

export { SNACKBAR_FAVORITE };
